import React, { Children, ReactNode, useEffect, useState } from "react";

import { ReactComponent as CloseIcon } from "../../assets/icons/close.svg";
import OutlinedButton from "../Buttons/OutlinedButton";
import PrimaryButton from "../Buttons/PrimaryButton";

type Props = {
  title: string;
  visible?: any;
  setModalOpen?: any;
  subtitle?: string;
  desc?: string;
  children?: any;
  onClose?: any;
  onSubmit?: any;
  onBack?: any;
  submitLoading?: boolean;
  handleCloseState?: any;
  buttonNext?: boolean;
  buttonBack?: boolean;
  onNext?: any;
  footer?: ReactNode;
  header?: ReactNode;
  largeContent?: "Large";
};

const Modal = (props: Props) => {
  const [visible, setVisible] = useState(props.visible);

  useEffect(() => {
    setVisible(props.visible);
  }, [props.visible]);
  const showHideClassName = visible
    ? "modal display-block"
    : "modal display-none";

  const closeModal = (e: React.MouseEvent<HTMLElement>) => {
    props.onClose && props.onClose();
    setVisible(!props.visible);
    e.stopPropagation();
    e.preventDefault();
    // if (visible === true) {
    //   setVisible(false);
    //   e.stopPropagation();
    //   e.preventDefault();
  };

  const returnModal = (e: React.MouseEvent<HTMLElement>) => {
    props.onBack && props.onBack();
    e.stopPropagation();
    e.preventDefault();
  };

  const submit = (
    e: React.MouseEvent<HTMLElement> | React.KeyboardEvent<HTMLElement>
  ) => {
    e.stopPropagation();
    // The submit button is disabled while the request runs, but Enter in the
    // body bypasses it — without this guard a slow submit can be sent twice.
    if (props.submitLoading) return;
    props.onSubmit && props.onSubmit();
  };

  const onEnterDown = (e: React.KeyboardEvent<HTMLElement>) => {
    if (e.key === "Enter") {
      e.preventDefault();
      submit(e);
    }
  };

  return (
    <div className={showHideClassName}>
      <div className={`modal-content ${props.largeContent ? "large-size" : ""}`}>
        <div className="modal-header">
          <div className="title">{props.title}</div>
          <div className="modal-icon" onClick={closeModal}>
            <CloseIcon />
          </div>
        </div>
        <div className="modal-body" onKeyPress={onEnterDown}>
          <div className="subtitle">{props.subtitle}</div>
          {props.desc && <div className="desc">{props.desc}</div>}
          {props.header && <div>{props.header}</div>}
          <div>{props.children}</div>
        </div>
        <div className="modal-footer">
          {!props.footer ? (
            <>
              {props.buttonNext ? (
                <PrimaryButton loading={props.onNext} onSubmit={submit}>
                  Next
                </PrimaryButton>
              ) : (
                <PrimaryButton loading={props.submitLoading} onSubmit={submit}>
                  Submit
                </PrimaryButton>
              )}
              {!props.buttonBack ? (
                <OutlinedButton onClick={closeModal}>Cancel</OutlinedButton>
              ) : (
                <OutlinedButton onClick={returnModal}>Back</OutlinedButton>
              )}
            </>
          ) : (
            props.footer
          )}
        </div>
      </div>
    </div>
  );
};

export default Modal;
